import React from 'react';

// ─── PRESETS ──────────────────────────────────────────────────────────────────
// Swap ACTIVE_PRESET to change the example. All math should be realistic.
// Arb formula: 1/decimal1 + 1/decimal2 < 1
// American to decimal: +X → (X/100)+1, -X → (100/X)+1

const PRESETS = {
  nfl: {
    emoji: '🏈',
    league: 'NFL',
    matchup: 'Eagles vs Cowboys',
    market: 'Moneyline',
    book1: { name: 'FanDuel', icon: 'fanduel.png', team: 'Philadelphia Eagles', american: '-140', stake: '$145.84' },
    book2: { name: 'DraftKings', icon: 'draftkings.jpeg', team: 'Dallas Cowboys', american: '+150', stake: '$100.00' },
    totalStaked: '$245.84',
    winEitherWay: '$250.00',
    profit: '+$4.16',
    profitPct: '+1.7%',
  },
  nba: {
    emoji: '🏀',
    league: 'NBA Playoffs',
    matchup: 'Thunder vs Lakers',
    market: 'Moneyline',
    book1: { name: 'FanDuel', icon: 'fanduel.png', team: 'Oklahoma City Thunder', american: '-120', stake: '$122.72' },
    book2: { name: 'DraftKings', icon: 'draftkings.jpeg', team: 'Los Angeles Lakers', american: '+125', stake: '$100.00' },
    totalStaked: '$222.72',
    winEitherWay: '$225.00',
    profit: '+$2.28',
    profitPct: '+1.02%',
  },
  mlb: {
    emoji: '⚾',
    league: 'MLB',
    matchup: 'Yankees vs Red Sox',
    market: 'Moneyline',
    book1: { name: 'FanDuel', icon: 'fanduel.png', team: 'New York Yankees', american: '+138', stake: '$100.00' },
    book2: { name: 'BetMGM', icon: 'betmgm.jpeg', team: 'Boston Red Sox', american: '-130', stake: '$134.52' },
    totalStaked: '$234.52',
    winEitherWay: '~$238.00',
    profit: '+$3.48',
    profitPct: '+1.48%',
  },
};

// ← Change this to 'nfl', 'nba', or 'mlb'
const ACTIVE_PRESET = 'nba';

// ─── COMPONENT ────────────────────────────────────────────────────────────────
function ArbitrageExample() {
  const ex = PRESETS[ACTIVE_PRESET];

  return (
    <div style={{
      backgroundColor: '#1a1f2e',
      border: '1px solid #2d3748',
      borderRadius: '14px',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '14px 20px',
        borderBottom: '1px solid #2d3748',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '13px', color: '#64748b' }}>{ex.emoji} {ex.league}</span>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff' }}>{ex.matchup}</span>
          <span style={{ fontSize: '12px', color: '#64748b' }}>· {ex.market}</span>
        </div>
        <div style={{
          padding: '4px 12px',
          backgroundColor: 'rgba(16, 185, 129, 0.12)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          borderRadius: '20px'
        }}>
          <span style={{ fontSize: '12px', fontWeight: '700', color: '#10b981' }}>{ex.profitPct} profit either way</span>
        </div>
      </div>

      {/* Bet slips */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        {[ex.book1, ex.book2].map((book, i) => (
          <div key={i} style={{
            padding: '20px',
            borderRight: i === 0 ? '1px solid #2d3748' : 'none',
            borderBottom: '1px solid #2d3748'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
              <img src={`/sportsbook-icons/${book.icon}`} alt={book.name}
                style={{ width: '24px', height: '24px', objectFit: 'contain', borderRadius: '5px' }} />
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#a0aec0' }}>{book.name}</span>
            </div>
            <div style={{ fontSize: '13px', color: '#64748b', marginBottom: '4px' }}>{book.team}</div>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#00d9ff', marginBottom: '12px' }}>{book.american}</div>
            <div style={{ padding: '8px 12px', backgroundColor: '#0f1419', borderRadius: '8px', border: '1px solid #2d3748' }}>
              <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '2px' }}>Stake</div>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff' }}>{book.stake}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Profit footer */}
      <div style={{
        padding: '16px 20px',
        background: 'linear-gradient(90deg, rgba(16,185,129,0.08) 0%, rgba(0,217,255,0.08) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', gap: '28px' }}>
          <div>
            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '2px' }}>Total staked</div>
            <div style={{ fontSize: '15px', fontWeight: '600', color: '#ffffff' }}>{ex.totalStaked}</div>
          </div>
          <div>
            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '2px' }}>Total return</div>
            <div style={{ fontSize: '15px', fontWeight: '600', color: '#ffffff' }}>{ex.winEitherWay}</div>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '11px', color: '#10b981', marginBottom: '2px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Profit</div>
          <div style={{ fontSize: '22px', fontWeight: '800', color: '#10b981' }}>{ex.profit}</div>
        </div>
      </div>
    </div>
  );
}

export default ArbitrageExample;
